module.exports = __webpack_public_path__ + "img/snowy-ibiza.d09b8c8b.jpg";